export default __webpack_public_path__ + "static/media/zone_management_orange.84fd1e40.svg";